import React, { useState } from "react";

import Category from "./Category";

import Questions from "./questions";

import "./index.sass";

function Form({ onSubmit }) {
  const [state, setState] = useState({
    total: 0,
    questions: [],
  });

  function onSubmitHandler(e) {
    e.preventDefault();
    console.log(state.questions);
    onSubmit(state.total, state.questions);
  }

  function onInputHandler(status, label) {
    const { value: points } = Questions.flatMap(each => each.questions).find(
      each => each.label === label
    );

    if (status) {
      setState({
        total: state.total + points,
        questions: [
          ...state.questions,
          {
            label,
            value: status ? true : false,
          },
        ],
      });
    } else
      setState({
        total: state.total - points,
        questions: state.questions.filter(each => each.label !== label),
      });
  }

  return (
    <form method="POST" className="form" onSubmit={onSubmitHandler}>
      {Questions.map(each => (
        <Category {...each} key={each.title} onInput={onInputHandler} />
      ))}
      <button className="button submit" type="submit">
        Avaliar Meu Perfil
      </button>
    </form>
  );
}

export default Form;
